import { render, staticRenderFns } from "./AIAssistanceButton.vue?vue&type=template&id=78aed2f7&"
import script from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports